import { render, staticRenderFns } from "./DailyPerformanceChart.vue?vue&type=template&id=7bc24b50&scoped=true&"
import script from "./DailyPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./DailyPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./DailyPerformanceChart.vue?vue&type=style&index=0&id=7bc24b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc24b50",
  null
  
)

export default component.exports